import { AspObject, AspObjectsSlot, ObjectType } from './AspObject';
import { DisplayObject } from './DisplayObject';
import * as enums from '../common/enums';
import * as settings from '../common/settings';
import { SensorCoreObject } from './SensorCoreObject';
import { PlotCoreObject } from './PlotCoreObject';
import { Point } from '../common/Point';
import { MatDialog } from '@angular/material/dialog';

export interface IService{
  showWindow(obj: any): void;
} 

export class SearchResult {
  obj: AspObject;
  identifier: string;
}

export interface IObjectsPool {
  isInitialized(): boolean;
  getObjectType(): ObjectType;
  getObject(objectId): AspObject;
  periodicUpdate(): boolean; // do periodic here, if needed
  deleteAllObjects();
  hookable(): boolean;
  clickable(): boolean;
  supportPicking(): boolean;
  supportSearch(): boolean; // Support textual search by operator
  getSlotAge(slotNumber: number): number; // Return slot age in seconds
  hookObject(obj: AspObject): boolean; // Return true if object was hooked
  searchObjects(searchPattern: string): SearchResult[];
  objectsCount(): number; // Return total objects count
  contextMenuActions(obj: AspObject): number[];
  globalMenuActions(obj: AspObject): number[];
  canBePicked(action: number, actionObj: AspObject,nextObj: AspObject): boolean;
  handleUserAction(action: number, obj: AspObject, mapMngr: IMapMngr, dialog?: MatDialog): boolean; // Return true if action was handled
  addSubscriber(subs);
  delSubscriber(subs);
  getAllObjects(): Map<any, AspObject>;
  getObjectsSlotsCount(): number;
  getCurrentSlot(): number;
  getObjectsSlot(slotNumber: number): AspObjectsSlot;
  addObject(obj: AspObject);
  deleteObject(obj: AspObject);
  toggleHookedObjectsHistory();
  toggleHookedObjectsHistory();
  changeHostilityOfTracks(hostility: number);
  forceSendPolyToSmart();
}

export interface ISensorsPool extends IObjectsPool {
  getSensorBySensorID(sensorID): SensorCoreObject;
  getSensorBySicSac(sic: number, sac: number): SensorCoreObject;
  genSicSac(sic: number, sac: number): number;
  getSensorLetterBySensorID(sensorID): string;
  getAllSensorIDs(): Array<number>;
  loadSensors(arr: any);
}

export interface IAlertPolygonsPool extends IObjectsPool {
  getAllAlertPolygonsIDs(): Array<number>;
}

export interface IAcousticVectorPool extends IObjectsPool {
}

export interface IPlotsPool extends IObjectsPool {
  getPlot(sensorID, sensorPlotID): PlotCoreObject;
}

export interface ITracksPool extends IObjectsPool {
}

export interface IAngularTracksPool extends IObjectsPool {
}

export interface IObjectsDrawer {
  drawMgr: any
  isInitialized(): boolean;
  periodicUpdate(): boolean; // do periodic here, if needed
  deleteAllObjects();
  getLayer(): NeWMI.Layer.DrawMgrLayer;
  isLayerVisible(): boolean;
  visibleCount(): number; // Return visible objects count
  subscribeObjectsPool();
  unsubscribeObjectsPool();
  addObjectToDm(obj: DisplayObject, dataKeys?, typeKeys?);
  updateObjectInDm(obj: DisplayObject, dataKeys?, typeKeys?);
  removeObjectFromDm(obj: DisplayObject, dataKeys?, typeKeys?);
  createObjectsFromPool();
  handleUserAction(action: number, obj: AspObject): boolean; // Return true if action was handled
  getObject(objectId): DisplayObject;
  getObjectsPool(): IObjectsPool;
  getMapMngr(): IMapMngr;
  getOpacity(): number;
  is3D(): boolean;
  drawUsingTemplate(): boolean;
  drawUsing3DModel(): boolean;
}

export interface IMapClickHandler {
  onObjectsClicked(objects: AspObject[]);
}

export interface IMapMngr {
  setCursor(cursor: string);
  restoreCursor();
  getCursor(): string;
  objectsAtLocation(point: NeWMI.Geometry.Point, onlyHookable?: boolean): AspObject[];
  getMapExtent(): settings.MapExtent;
  setMapExtent(extent: settings.MapExtent);
  setMapCenter(coord: Point);
  getMap(): any;
  handleUserAction(action: number, obj: AspObject): boolean; // Return true if action was handled
  getObject(objectId): DisplayObject;
  getDynamicCenterId();
  setDynamicCenterId(objectId);
  activateDefaultTool();
  defaultToolActive(): boolean;
  redrawMap();
  mouseMapLocation();
  pixelToMapLocation(pixel: Point): Point;
  isMainMap(): boolean;
  isMapPanning(): boolean;
  is3D(): boolean;
  getSizeByZoomValue(): number;
}
